<template>
</template>

<script>
    export default {

        props: { 
            id: null, 
            options: null,
            labels: null,
            passedLabel: null,
            noProgress: null,
            bus: null
        },

        data: function() {
            return {
                defaultOptions: {
                    progressBar: true, 
                    timeOut: "2000"
                },
                noProgressOptions: {
                    closeButton: true,
                },
                defaultLabels: {
                    success: lang.polaris.form.saved,
                    error: lang.polaris.form.error
                },
                finalOptions: null,
                finalLabels: null
            }
        },
        
        created: function() {
            var that = this;

            // Init
            var defaultOptions = this.noProgress ? this.noProgressOptions : this.defaultOptions;
            this.finalOptions = this.options ? this.options : defaultOptions;
            this.finalLabels = this.labels ? this.labels : this.defaultLabels;

            this.bus.$on(that.id+'-success', function(label) {
                var message = that.passedLabel && label != undefined ? label : that.finalLabels.success;
                if (typeof message === 'object') {
                    message = message.message
                }
                window.toastr.success(message);
            });

            this.bus.$on(that.id+'-error', function(label) {
                var message =  that.passedLabel && label != undefined ? label : that.finalLabels.error;
                if (typeof message === 'object') {
                    message = message.message
                }
                window.toastr.error(message);
            });

        },
        
        mounted: function() {
            window.toastr.options = this.finalOptions;
        }
    }
</script>
